import React, { useRef, useEffect } from "react";
import {
  FormTab,
  TextInput,
  Record,
  regex,
  minLength,
  maxLength,
  TabbedForm,
} from "react-admin";
import { required, email, useTranslate } from "react-admin";
import "../../common/styles/form-style.css";
import { useAppData } from "../../../common/hooks/useAppData";
import Inputmask from "inputmask";
import {
  FleetManagerDto,
  FleetManagerListDto,
} from "../../../common/data/service-proxies";
import { FleetManagerSettingsFormTab } from "./FleetManagerSettingsFormTab";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface FleetManagerFormProps {
  record?: FleetManagerDto & FleetManagerListDto & Record;
  toolbar?: React.ReactElement;
  isEdit?: boolean;
}

export const FleetManagerForm = ({
  isEdit,
  ...props
}: FleetManagerFormProps) => {
  const companies = useAppData((x) => x.companies) ?? [];
  const roles =
    useAppData((x) => x.roles)?.map((x) => ({ id: x.name, name: x.name })) ??
    [];
  const groups = useAppData((x) => x.groups) ?? [];
  const phoneRef = useRef<HTMLInputElement>(null);
  const translate = useTranslate();

  useEffect(() => {
    if (!phoneRef.current) {
      return;
    }

    var im = new Inputmask("(999) 999-9999");
    im.mask(phoneRef.current);
  });

  return (
    <TabbedForm className="form-create-edit" variant="outlined" {...props}>
      <FormTab label="resources.admin-fleet-managers.labels.personalInformation">
        <ProtectedElement source="name">
          <TextInput
            source="name"
            label="resources.admin-fleet-managers.labels.name"
            validate={[required(), minLength(2), maxLength(30)]}
            autoComplete="given-name"
          />
        </ProtectedElement>
        <ProtectedElement source="surname">
          <TextInput
            source="surname"
            label="resources.admin-fleet-managers.labels.surname"
            validate={[required(), minLength(2), maxLength(30)]}
            autoComplete="family-name"
          />
        </ProtectedElement>
        <ProtectedElement source="email">
          <TextInput
            source="email"
            label="resources.common.labels.email"
            validate={[required(), email()]}
            disabled={isEdit}
          />
        </ProtectedElement>
        <ProtectedElement source="phoneNumber">
          <TextInput
            inputRef={phoneRef}
            source="phoneNumber"
            label="resources.common.labels.phone"
            validate={[
              required(),
              regex(
                /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/,
                translate("resources.common.labels.mustBeValidPhoneNumber")
              ),
            ]}
          />
        </ProtectedElement>
      </FormTab>
      <FleetManagerSettingsFormTab
        companies={companies}
        roles={roles}
        groups={groups}
      />
    </TabbedForm>
  );
};
